import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Busonrentinchakanpune() {



  const cardData =
  {
    keyword: 'Bus On Rent in Chakan Pune',
    heading: 'Sanavi Travels: Bus On Rent in Chakan Pune',
    headingDescription: 'Sanavi Travels offers reliable Bus On Rent in Chakan Pune, providing safe, comfortable, and spacious transportation for families, groups, corporate trips, school excursions, weddings, and outstation travel. Our fleet of well-maintained AC and Non-AC buses, mini buses, and luxury coaches ensures smooth rides, ample seating, and sufficient luggage space for hassle-free journeys. With professional drivers, flexible one-way and round-trip bus rental packages, transparent pricing, and 24/7 booking support, bus rental in Chakan Pune is perfect for local travel, sightseeing tours, corporate events, and long-distance trips. Choose Sanavi Travels for trusted bus rental services in Chakan Pune, delivering comfort, safety, and a seamless travel experience for every occasion.',

    top: 'Top Places to Visit in Chakan Pune with Sanavi Travels',


"topPlaces": [
  {
    "title": "Chakan Town",
    "description": "Chakan is an industrial and historic town in Pune district, strategically located on the Pune–Nashik highway. Known as a major automotive and manufacturing hub, it houses several automobile plants, factories, and industrial estates. Beyond its industrial prominence, Chakan has historical significance due to the Chakan Fort, making it a blend of heritage and modern development."
  },
  {
    "title": "Chakan Fort",
    "description": "Chakan Fort, dating back to the 17th century, is famous for the heroic 13-month defense by Maratha warriors against the Mughal army. The fort features robust bastions, gates, and ruins that reflect Maratha-era architecture. History enthusiasts and photographers visit to explore the fort’s historical legacy and panoramic views of the surrounding plains."
  },
  {
    "title": "Industrial Parks and Factories",
    "description": "Chakan has emerged as one of India’s leading industrial hubs, especially in the automotive sector, with major companies such as Tata, Mahindra, and Mercedes-Benz having manufacturing units here. Visitors interested in industrial tourism can explore these modern facilities and learn about large-scale production."
  },
  {
    "title": "Temples of Chakan",
    "description": "Chakan hosts several temples, including smaller shrines dedicated to local deities and Lord Shiva. These temples reflect the cultural and spiritual traditions of the town and provide tranquil spaces for devotees and visitors alike."
  },
  {
    "title": "Agricultural Landscape Surrounding Chakan",
    "description": "Despite its industrial growth, the areas around Chakan are primarily agricultural, with sugarcane, vegetables, and poultry farming being prominent. The rural landscape provides scenic views and insight into traditional farming practices."
  },
  {
    "title": "Local Markets and Cuisine",
    "description": "Chakan’s local markets are vibrant, offering fresh produce, traditional snacks, and local delicacies. Street food stalls and small eateries provide an authentic taste of Maharashtrian cuisine, adding to the town’s cultural charm."
  },
  {
    "title": "Chakan Riverside and Natural Spots",
    "description": "The nearby small rivers and streams create peaceful spots for morning walks and picnics. During the monsoon, the surrounding landscape becomes lush green, enhancing the beauty of the region."
  },
  {
    "title": "Weekend Getaways from Chakan",
    "description": "Chakan’s location makes it a convenient base for visiting nearby forts, hill stations, and cultural destinations in Pune district. Popular excursions include Sinhagad, Rajgurunagar, and Mulshi, offering a mix of adventure, nature, and history."
  },
  {
    "title": "Heritage Walks and Photography",
    "description": "The historic structures, fort walls, and rural surroundings provide excellent opportunities for heritage walks and photography. Visitors can capture Maratha-era architecture, scenic landscapes, and cultural moments in Chakan."
  },
  {
    "title": "Cultural and Religious Festivals",
    "description": "Chakan celebrates traditional Maharashtrian festivals such as Ganesh Chaturthi, Diwali, and Shiv Jayanti with enthusiasm. These events showcase folk music, dance, rituals, and community participation, giving visitors an immersive cultural experience."
  }
]
,



"services": [
{
"name": "Bus On Rent in Chakan Pune",
"description": "Bus On Rent in Chakan Pune provides spacious and comfortable buses for group travel, corporate outings, weddings, and long-distance trips. Equipped with modern amenities, professional drivers, and safety features, it ensures a smooth, safe, and hassle-free journey. Perfect for industrial tours, family trips, pilgrimages, and social events, this service combines convenience, reliability, and affordability for all types of group transportation in and around Chakan."
},
{
"name": "Bus Hire Chakan",
"description": "Bus Hire Chakan offers flexible and convenient rental services for families, corporate teams, and large groups traveling for weddings, industrial tours, and leisure trips. Well-maintained buses, experienced drivers, and punctual service guarantee safe, comfortable, and timely transportation tailored to your schedule."
},
{
"name": "AC Bus Chakan",
"description": "AC Bus Chakan ensures a cool and comfortable journey for travelers with air-conditioned interiors, spacious seating, and professional chauffeurs. Ideal for corporate clients, families, and tourists, it provides a relaxing and enjoyable travel experience for both short and long-distance trips, enhancing passenger comfort throughout the journey."
},
{
"name": "Luxury Bus Chakan",
"description": "Luxury Bus Chakan offers premium travel services with elegant interiors, comfortable seating, advanced amenities, and skilled drivers. Suitable for weddings, corporate events, VIP tours, and leisure trips, it guarantees a safe, stylish, and memorable journey for all passengers."
},
{
"name": "Corporate Bus Chakan",
"description": "Corporate Bus Chakan provides reliable and organized transportation solutions for businesses, employee commutes, team outings, and corporate events. Comfortable seating, professional drivers, and timely service make corporate travel safe, stress-free, and efficient in Chakan and nearby areas."
},
{
"name": "Employee Transport Bus Chakan",
"description": "Employee Transport Bus Chakan caters to industrial and corporate sectors, providing safe, timely, and organized transport for employees. Well-maintained buses, experienced drivers, and flexible scheduling ensure efficient daily commute or event travel, making it ideal for factories, offices, and industrial areas."
},
{
"name": "Wedding Bus Chakan",
"description": "Wedding Bus Chakan offers spacious and elegant buses for transporting guests to and from wedding venues. Professional drivers, comfortable seating, and reliable service ensure stress-free, safe, and enjoyable travel for family members, friends, and relatives attending weddings in Chakan and surrounding areas."
},
{
"name": "Outstation Bus Chakan",
"description": "Outstation Bus Chakan provides dependable long-distance travel solutions for families, corporate groups, and tourists. With experienced drivers, well-maintained buses, and planned itineraries, it ensures safe, comfortable, and convenient journeys to nearby cities, tourist attractions, and pilgrimage sites."
},
{
"name": "Affordable Bus Chakan",
"description": "Affordable Bus Chakan delivers cost-effective bus rental services for families, groups, and corporate clients without compromising on comfort, safety, or quality. Ideal for weddings, industrial tours, and sightseeing trips, it ensures reliable transport with professional drivers at competitive rates."
},
{
"name": "Chauffeur Driven Bus Chakan",
"description": "Chauffeur Driven Bus Chakan provides a stress-free travel experience with professional drivers handling navigation, traffic, and schedules. Perfect for weddings, corporate outings, group trips, and industrial visits, ensuring safe, comfortable, and convenient transportation."
},
{
"name": "Best Bus Service Chakan",
"description": "Best Bus Service Chakan guarantees high-quality, spacious buses with modern amenities and expert drivers. Suitable for corporate events, weddings, family trips, and industrial tours, it ensures punctual, safe, and comfortable travel for all types of group transportation in Chakan."
},
{
"name": "Industrial Area Bus Chakan",
"description": "Industrial Area Bus Chakan specializes in transporting employees and groups to and from Chakan’s industrial hubs. Well-maintained buses, professional chauffeurs, and reliable scheduling ensure safe, convenient, and timely travel for workers, corporate teams, and business visitors."
},
{
"name": "Online Bus Booking Chakan",
"description": "Online Bus Booking Chakan allows travelers and businesses to book buses easily and conveniently with instant confirmation. Multiple bus options, flexible scheduling, and secure online payments simplify travel planning for weddings, corporate events, industrial tours, and group outings."
},
{
"name": "Event Bus Chakan",
"description": "Event Bus Chakan provides dedicated transportation for weddings, corporate gatherings, social events, and industrial tours. Spacious seating, professional drivers, and timely service ensure organized, safe, and comfortable travel for all attendees, making every event seamless and enjoyable."
},
{
"name": "Chakan Travel Bus",
"description": "Chakan Travel Bus offers comprehensive transportation solutions for sightseeing, weddings, corporate events, industrial tours, and long-distance travel. Reliable buses, professional chauffeurs, and high-quality service guarantee safe, comfortable, and convenient journeys for families, groups, and businesses traveling in and around Chakan."
}
],
"tableData": [
["Bus On Rent in Chakan Pune", "Bus Hire Chakan"],
["AC Bus Chakan", "Luxury Bus Chakan"],
["Corporate Bus Chakan", "Employee Transport Bus Chakan"],
["Wedding Bus Chakan", "Outstation Bus Chakan"],
["Affordable Bus Chakan", "Chauffeur Driven Bus Chakan"],
["Best Bus Service Chakan", "Industrial Area Bus Chakan"],
["Online Bus Booking Chakan", "Event Bus Chakan"],
["Chakan Travel Bus", "—"]
]
,


"whychoose": [
  {
    "WhyChooseheading": "Bus On Rent in Chakan Pune with Sanavi Travels",
    "WhyChoosedescription": "Sanavi Travels offers reliable and comfortable bus rental services in Chakan Pune, ideal for group outings, corporate events, school trips, family tours, and pilgrimages."
  },
  {
    "WhyChooseheading": "Spacious and Well‑Maintained Buses",
    "WhyChoosedescription": "Our buses are clean, air‑conditioned, and regularly serviced to ensure a smooth and enjoyable journey throughout Chakan Pune and nearby areas."
  },
  {
    "WhyChooseheading": "Experienced and Professional Drivers",
    "WhyChoosedescription": "Our licensed and courteous drivers are familiar with Chakan Pune routes, ensuring safe, punctual, and stress‑free travel for your group."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
    "WhyChoosedescription": "Sanavi Travels provides clear and upfront pricing for bus rentals in Chakan Pune, including fuel, tolls, and driver allowances, with no hidden fees."
  },
  {
    "WhyChooseheading": "24/7 Customer Support",
    "WhyChoosedescription": "Our customer support team is available round the clock to assist with bookings, travel queries, and itinerary planning for your bus rental in Chakan Pune."
  },
  {
    "WhyChooseheading": "Flexible Rental Packages",
    "WhyChoosedescription": "Choose from hourly, half‑day, full‑day, or customized rental packages based on your group’s needs and travel schedule."
  },
  {
    "WhyChooseheading": "Safe and Sanitized Vehicles",
    "WhyChoosedescription": "All buses are thoroughly cleaned and sanitized before every trip to ensure a safe and hygienic travel experience."
  },
  {
    "WhyChooseheading": "Reliable and On‑Time Service",
    "WhyChoosedescription": "We guarantee punctual pickups and dependable service, making Sanavi Travels a trusted choice for bus rentals in Chakan Pune."
  }
]

}

const faqData = [
  {
    question: 'Does Sanavi Travels provide bus rental services in Chakan Pune?',
    answer: 'Yes, Sanavi Travels offers dependable bus rental services in Chakan Pune for various travel needs.'
  },
  {
    question: 'How can I book a bus in Chakan Pune?',
    answer: 'You can easily book a bus through our website or by contacting our 24x7 customer support team.'
  },
  {
    question: 'What types of buses are available for rent in Chakan Pune?',
    answer: 'Sanavi Travels offers a variety of buses including mini buses, 20‑seater, 32‑seater, 45‑seater, and 50‑seater options to suit your group size.'
  },
  {
    question: 'Are the drivers experienced with routes around Chakan Pune?',
    answer: 'Yes, our drivers are licensed, professional, and familiar with Chakan Pune routes, ensuring safe and timely travel.'
  },
  {
    question: 'Can I choose custom pickup and drop‑off locations in Chakan Pune?',
    answer: 'Absolutely. You can select your preferred pickup and drop‑off locations anywhere in Chakan Pune and nearby areas.'
  },
  {
    question: 'Is the bus service in Chakan Pune available 24x7?',
    answer: 'Yes, Sanavi Travels offers round‑the‑clock bus rental services in Chakan Pune to suit your travel schedule.'
  },
  {
    question: 'Are the buses sanitized before every trip?',
    answer: 'Yes, all buses are thoroughly cleaned and sanitized to ensure a safe and hygienic travel experience.'
  },
  {
    question: 'What payment options are available for bus rentals?',
    answer: 'We accept UPI, credit/debit cards, digital wallets, bank transfers, and corporate payments for your bus rental bookings.'
  },
  {
    question: 'Is customer support available during the journey?',
    answer: 'Yes, our 24x7 customer support team is available throughout your trip in Chakan Pune.'
  }
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Pratik Kulkarni',
    feedback: 'We rented a bus in Chakan Pune from Sanavi Travels — very comfortable journey and excellent service!',
    rating: 5
  },
  {
    id: 2,
    name: 'Ms. Rutuja More',
    feedback: 'Sanavi Travels provided a clean and reliable bus for our group travel in Chakan Pune. Highly recommended!',
    rating: 5
  }
];





































































































































































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Shirdi Tempo Traveller On Rent", link: "pune-to-shirdi-tempo-traveller-on-rent" },
    { place: "/images/keyword/3.jpg", text: "Pune to Mahabaleshwar Tempo Traveller on Rent", link: "pune-to-mahabaleshwar-tempo-traveller-on-rent" },
    { place: "/images/keyword/4.jpg", text: "Pune to Goa Tempo Traveller Hire", link: "pune-to-goa-tempo-traveller-hire" },
    { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Tempo Traveller on Rent", link: "pune-to-mumbai-tempo-traveller-on-rent" },
    { place: "/images/keyword/6.jpg", text: "Pune to Konkan Darshan Tempo Traveller Hire", link: "pune-to-konkan-darshan-tempo-traveller-hire" },
    { place: "/images/keyword/7.jpg", text: "Pune to Nashik Tempo Traveller On Rent", link: "pune-to-nashik-tempo-traveller-on-rent" },
    { place: "/images/keyword/8.jpg", text: "Tempo Traveller On Rent for Pune Darshan", link: "tempo-traveller-on-rent-for-pune-darshan" },
    { place: "/images/keyword/9.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
    { place: "/images/keyword/10.jpg", text: "13 Seater Tempo Traveller On Rent in Pune", link: "13-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/11.jpg", text: "17 Seater Tempo Traveller on Rent in Pune", link: "17-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/12.jpg", text: "20 Seater Luxury Bus On Rent Pune", link: "20-seater-luxury-bus-on-rent-pune" },
    { place: "/images/keyword/13.jpg", text: "26 Seater Tempo Traveller On Rent in Pune", link: "26-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/14.jpg", text: "32 Seater Luxury Bus On Rent in Pune", link: "32-seater-luxury-bus-on-rent-in-pune" },
    { place: "/images/keyword/15.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/16.jpg", text: "45 Seater Bus On Rent in Pune", link: "45-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/17.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/18.jpg", text: "Bus Hire for School Trips in Pune", link: "bus-hire-for-school-trips-in-pune" },
    { place: "/images/keyword/19.jpg", text: "Bus booking for Wedding in Pune", link: "bus-booking-for-wedding-in-pune" },
    { place: "/images/keyword/20.jpg", text: "Bus Booking for Marriage in Pune", link: "bus-booking-for-marriage-in-pune" },
    { place: "/images/keyword/21.jpg", text: "Bus Service for Corporate in Pune", link: "bus-service-for-corporate-in-pune" },
    { place: "/images/keyword/22.jpg", text: "Bus on Rent For Event in Pune", link: "bus-on-rent-for-event-in-pune" },
    { place: "/images/keyword/23.jpg", text: "Bus Hire for Outstation in Pune", link: "bus-hire-for-outstation-in-pune" },
    { place: "/images/keyword/24.jpg", text: "AC Bus On Rent in Pune", link: "ac-bus-on-rent-in-pune" },
    { place: "/images/keyword/25.jpg", text: "Pune Bus Hire Rental Service", link: "pune-bus-hire-rental-service" },
  ];









const jsonData = {
  "@context": "https://schema.org",
  "@type": "BusTrip",
  "name": "Bus On Rent in Chakan Pune - Sanavi Travels",
  "description": "Book a bus on rent in Chakan Pune with Sanavi Travels. AC, luxury, and affordable chauffeur-driven buses available for corporate trips, weddings, employee transport, outstation tours, industrial area travel, and events. Online booking available.",
  "touristType": "Corporate Travel, Wedding, Employee Transport, Outstation, Industrial Travel",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "28"
  }
};






  return (
    <div>

<Helmet>
  <title>
    Bus On Rent in Chakan Pune | Sanavi Travels
  </title>

  <meta
    name="description"
    content="Rent a bus in Chakan Pune with Sanavi Travels. AC, luxury, and affordable chauffeur-driven buses for corporate trips, weddings, employee transport, outstation tours, and events. Book online now."
  />

  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>

      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1 className="text-anime-style-3 text-center text-white" data-cursor="-opaque">
                  <h3> {cardData.keyword}</h3>
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>





      <section>
        <div className="container-fluid" >
          <div className="row container-fluid p-0">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/162.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>



              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sanavi Travels </span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sanavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+917387507373" className="pc-call">+91 7387507373</a>
                      <a href="tel:+919595532929" className="pc-call">+91 9595532929</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/917387507373"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+917387507373" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@sanavitravels.com" className="pc-email">
                      booking@sanavitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sanavi Travels</strong><br />
                      OFFICE NO.6, GROUND FLOOR GAT NO.1110,
                      SHREE GOPINATH MAHARAJ VYAPARI SHED SHIVAJI CHOWK, VARVAND TAL DAUND,
                      DIST PUNE – 412215
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Busonrentinchakanpune;